import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import { registrationInputMaxLength } from "app/utils/const";
import { useEffect, useState } from "react";
import { IntlShape } from "react-intl";

type Props = {
  handleChange: (id: string, value: string) => void;
  dateOfBirth: string;
  gender: string;
  intl: IntlShape;
  dateOfBirthValidationError: boolean;
  genderValidationError: boolean;
};

const DateOfBirthGender = ({
  handleChange,
  dateOfBirth,
  gender,
  intl,
  dateOfBirthValidationError,
  genderValidationError,
}: Props) => {
  const [errorDateOfBirth, setErrorDateOfBirth] = useState<string>("");
  const [errorGender, setErrorGender] = useState<string>("");

  const validateDateOfBirth = (id: string, value: string) => {
    if (value.length < 2) {
      setErrorDateOfBirth(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorDateOfBirth("");
    }
  };

  const validateGender = (id: string, value: string) => {
    if (
      value.length < 2 ||
      value === intl.formatMessage({ id: "settings-select-gender" })
    ) {
      setErrorGender(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorGender("");
    }
  };

  useEffect(() => {
    if (dateOfBirthValidationError) {
      validateDateOfBirth("dateOfBirth", "");
    }
    if (genderValidationError) {
      validateGender("gender", "");
    }
  }, [genderValidationError, dateOfBirthValidationError]);

  return (
    <div className="form-details__row form-details__row--two-cols">
      <div className="form-details__col">
        <InputWithLabel
          label={intl.formatMessage({
            id: "settings-birth",
          })}
          inputId={"dateOfBirth"}
          value={dateOfBirth}
          onValueChange={handleChange}
          key={"dateOfBirth"}
          type={"date"}
          required={true}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={intl.formatMessage({
            id: "settings-birth",
          })}
          validateInput={true}
          error={errorDateOfBirth}
          handleValidation={validateDateOfBirth}
        />
      </div>
      <div className="form-details__col">
        <div>
          <label>
            {intl.formatMessage({
              id: "settings-gender",
            })}
            <span className="required">*</span>
          </label>
        </div>
        <div className="form-details__row--input">
          <select
            defaultValue={
              gender || intl.formatMessage({ id: "settings-select-gender" })
            }
            onChange={e => handleChange("gender", e.target.value)}
            onBlur={e => validateGender("gender", e.target.value)}
            className={`${errorGender ? "error" : ""}`}
          >
            <option
              value={intl.formatMessage({
                id: "settings-select-gender",
              })}
            >
              {intl.formatMessage({
                id: "settings-select-gender",
              })}
            </option>
            <option value={"male"}>
              {intl.formatMessage({
                id: "settings-gender-male",
              })}
            </option>
            <option value={"female"}>
              {intl.formatMessage({
                id: "settings-gender-female",
              })}
            </option>
            <option value={"Other"}>
              {intl.formatMessage({
                id: "register-heardaboutusoptions-other",
              })}
            </option>
          </select>
        </div>
        {errorGender && <span className="error-message">{errorGender}</span>}
      </div>
    </div>
  );
};

export default DateOfBirthGender;
